import Bold from "./bold";
import Italic from "./italic";
import Underline from "./underline";

const tagMappings = { bold: Bold, italic: Italic, underline: Underline };

const Text = ({ value, marks }) => {
  if (!marks || marks.length === 0) {
    return value;
  }

  return marks.reduce((acc, { type }, index) => {
    const Tag = tagMappings[type];

    return <Tag key={`${type}-${index}`}>{acc}</Tag>;
  }, value);
};

export default Text;
